export default __webpack_public_path__ + "static/media/x_1.2.edcb1ccd.svg";